import Sidebar from './components/Sidebar.jsx';
import Topbar from './components/Topbar.jsx';
import { RouterProvider, useRouter } from './lib/router.jsx';
import { SessionProvider, useSession } from './lib/session.jsx';
import { matchRoute } from './lib/nav.js';
import NotFound from './sections/NotFound.jsx';

import Overview from './sections/Overview.jsx';
import CallHistory from './sections/CallHistory.jsx';
import Voicemail from './sections/Voicemail.jsx';
import Extensions from './sections/Extensions.jsx';
import ExtensionDetail from './sections/ExtensionDetail.jsx';
import Minutes from './sections/Minutes.jsx';
import Queues from './sections/Queues.jsx';
import CallRouting from './sections/CallRouting.jsx';
import BusinessHours from './sections/BusinessHours.jsx';
import Settings from './sections/Settings.jsx';

const SECTIONS = {
  overview: Overview,
  history: CallHistory,
  voicemail: Voicemail,
  extensions: Extensions,
  'extension-detail': ExtensionDetail,
  minutes: Minutes,
  queues: Queues,
  routing: CallRouting,
  hours: BusinessHours,
  settings: Settings,
};

function Shell() {
  const session = useSession();
  const { path } = useRouter();

  // matchRoute is role-aware, so an unauthorised path lands on the same
  // "not found" as a typo. The backend is what actually enforces this.
  const route = matchRoute(path, session.role);
  const Section = route ? SECTIONS[route.id] : NotFound;
  const title = route ? route.label : 'Not found';

  return (
    <div className="shell">
      <Sidebar />
      <main className="main">
        <Topbar title={title} />
        <div className="section-body">
          <Section {...(route?.params ?? {})} />
        </div>
      </main>
    </div>
  );
}

export default function App() {
  return (
    <SessionProvider>
      <RouterProvider>
        <Shell />
      </RouterProvider>
    </SessionProvider>
  );
}
